import { makeCygnusApiCall } from "../../../api/api";
import { COIRegistryEntry } from "./COIRegistry.types";

export const fetchCOIRegistryEntries = async (): Promise<COIRegistryEntry[]> => {
  const response = await makeCygnusApiCall({
    type: "GET",
    url: "/firm_setup/coi_registry",
    show_message: false,
    customized_success_message: "Fetched COI Registry entries successfully.",
    customized_failure_message: "Failed to fetch COI Registry entries.",
    customized_error_message: "Error occurred while fetching COI Registry entries.",
    isblob: false,
    forMDM: true,
  });

  return response?.data ?? [];
};
